import { render } from "./SegmentedButton.vue?vue&type=template&id=954bdad6"
import script from "./SegmentedButton.vue?vue&type=script&lang=js"
export * from "./SegmentedButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__